import React from 'react'

type StepperProps = {
  activeStep: number
  steps: readonly { id: number; label: string }[]
}

const InvestV2Stepper = ({ activeStep, steps }: StepperProps) => {
  return (
    <nav
      className='invest-v2__stepper'
      aria-label='Investment progress'
      data-testid='invest-v2-stepper'
    >
      <ol className='invest-v2__stepper-list'>
        {steps.map((step, index) => {
          const isActive = step.id === activeStep
          const isComplete = step.id < activeStep
          const prevStepId = index > 0 ? steps[index - 1].id : 0
          const connectorDone = index > 0 && activeStep > prevStepId

          return (
            <li key={step.id} className='invest-v2__stepper-node'>
              {index > 0 && (
                <span
                  className={`invest-v2__stepper-connector ${
                    connectorDone ? 'invest-v2__stepper-connector--done' : ''
                  }`}
                  aria-hidden
                />
              )}
              <div
                className={`invest-v2__stepper-pill ${
                  isActive ? 'invest-v2__stepper-pill--active' : ''
                } ${isComplete && !isActive ? 'invest-v2__stepper-pill--complete' : ''}`}
                aria-current={isActive ? 'step' : undefined}
              >
                <span className='invest-v2__stepper-pill-inner'>
                  <span className='invest-v2__stepper-pill-index'>{step.id}.</span>
                  <span className='invest-v2__stepper-pill-name'>{step.label}</span>
                </span>
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export { InvestV2Stepper }
